<template>
  <div class="affiliated-permission-trade">
    <span class="section-title"> Trade</span>
    <p class="subtitle mt-1">Aqui você define o que seu associado pode fazer ou não, em relação as ofertas de trade</p>
    <div class="cards">
      <permission-card
        v-for="(permission, index) in permissions"
        :key="index"
        v-model="localFranchiseePermissions[permission.permission]"
        :title="permission.title"
        :subtitle="permission.subtitle"
        :alertMessage="permission.alert"
      />
    </div>
    <mf-action-buttons
      class="mt-4"
      :primary-button="{
        text: 'Salvar alterações',
        action: save,
        isVisible: true,
        isDisabled: disableButtons,
        isLoading: loadingSave,
      }"
      :extra-button="{
        text: 'Descartar alterações',
        action: cancel,
        isVisible: true,
        isDisabled: disableButtons,
      }"
    />
  </div>
</template>

<script>
import TradePermissions from '@/modules/configuracoes/permissionamento-filiado/mocks/TradePermissions.js'
import isEqual from 'lodash/isEqual'

export default {
  components: {
    PermissionCard: () => import('./PermissionCard.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    franchiseePermissions: {
      type: Object,
      default: () => {},
    },
    loadingSave: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    permissions: [],
    localFranchiseePermissions: {},
  }),
  computed: {
    disableButtons() {
      return isEqual(this.localFranchiseePermissions, this.franchiseePermissions)
    },
  },
  watch: {
    localFranchiseePermissions: {
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  mounted() {
    this.localFranchiseePermissions = { ...this.value }
    this.permissions = [...TradePermissions]
  },
  methods: {
    save() {
      this.$emit('save', this.localFranchiseePermissions)
    },
    cancel() {
      this.localFranchiseePermissions = JSON.parse(JSON.stringify(this.franchiseePermissions))
      this.$snackbar({ message: 'Alterações descartadas com sucesso', snackbarColor: 'success' })
    },
  },
}
</script>

<style lang="scss" scoped>
.affiliated-permission-trade {
  padding: 24px 16px 0 18px;

  .subtitle {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .cards {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  }
}
</style>
